<app-offer-main
  [type]="'ata'"
  [projectInfo]="projectData | async"
  (updateProjectAtaNavCount)="setProjectData()"
></app-offer-main>
